import {
    get,
    post,
    del
} from '@/util/request'
import { sha256 } from '@/util/encryption';

//登录逻辑
export const userLogin = (parmas) => {
    // return post(`http://localhost:44397/InjuryPlatformApi/api/app/user/login/${parmas.userId}?password=${parmas.password}`);
    return post(`/api/app/user/login?userCode=${parmas.userCode}&password=${sha256(parmas.password)}`);
}

// 发送验证码
export const getMobileCodeApi = (data, parmas={}) => {
    return post('/api/app/user/sendMessage', data, parmas);
}

// 登录
export const getUserInfoApi = (data, parmas={}) => {
    return post('/api/app/user/getUserInfo', data, parmas);
}